module.exports = __webpack_public_path__ + "img/thumbnail_CaliforniaSeaLion_m_albino.b877f7ea.png";